import { SocketIoClient } from '../../../functions/SocketIo.js'

class WsEvent extends SocketIoClient {
  #messageCallback = null
  /** @type {string} */
  eventName
  /** @type {import('socket.io-client').Socket} */
  eventSocket

  /**
   * @param eventName {string}
   */
  constructor (eventName) {
    super()
    this.eventName = eventName
    this.eventSocket = this.socketIo.createSocket(`/event/${eventName}`)

    this.eventSocket.on('message', args => {
      console.log(args)
      this.#messageCallback?.(args)
    })
  }

  send (args) {
    console.log(args)
    this.eventSocket.emit('broadcast', args)
  }

  messageCallback (callback) {
    this.#messageCallback = callback
  }

  destroy () {
    this.eventSocket.disconnect()
    super.destroy()
  }
}

export default () => {
  return eventName => {
    return new WsEvent(eventName)
  }
}
